import { Typography } from "@mui/material";

const UserListComponent = ({ title, data }) => {
  return (
    <Typography sx={{ fontWeight: 600, fontSize: 15, mb: 0.5 }}>
      {title} :{" "}
      <Typography variant="span" sx={{ fontWeight: 400 }}>
        {data}
      </Typography>
    </Typography>
  );
};

export default UserListComponent;
